// quotes wizard
export const GET_ALL_ADMIN = 'GET_ALL_ADMIN'
export const SET_SELECTED_QUOTE_ADMIN = 'SET_SELECTED_QUOTE_ADMIN'
export const GET_ALL_BY_STATE = 'GET_ALL_BY_STATE'
export const UPDATE_QUOTE = 'UPDATE_QUOTE'
export const LOAD_MODELS_BY_MAKE_AND_YEAR = 'LOAD_MODELS_BY_MAKE_AND_YEAR'
export const SET_PAQ_ACCESS_TOKEN = 'SET_PAQ_ACCESS_TOKEN'
export const SET_ADMIN_SUGGESTED_OFFER = 'SET_ADMIN_SUGGESTED_OFFER'




// WEBPACK FOOTER //
// ./src/store/modules/quotes/mutation-types.js